// extracted by css-extract-rspack-plugin
export default {"icon":"AY5OHdyMNCTSetlovyZZ"};